import React from "react";
import { Crown } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-800 py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 mb-6 md:mb-0">
            <Crown className="h-6 w-6 text-yellow-400" />
            <span className="text-lg font-bold text-white tracking-wider">
              GOLDEN CORTEX
            </span>
          </Link>

          {/* Copyright and Links */}
          <div className="text-center md:text-right">
            <p className="text-gray-400 text-sm mb-2">
              Copyright 2025 © Golden Cortex
            </p>
            <p className="text-gray-400 text-sm mb-2">
              All Rights Reserved.
            </p>
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-400">info@goldencortex.net</span>
              <span className="text-gray-400">SP: +34 617 500 996</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;